module.exports = __webpack_public_path__ + "static/media/Apple_logo_black.10016100.svg";